// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const envBase = {
  /*
    Generic
   */

  // Env.
  envName: 'Dev',
  production: false,
  debug: true,

  // URLs
  glqBaseUrl: 'https://ccp-dev-gql.cbwsoft.com:4021/',
  gqlUrl: 'https://ccp-dev-gql.cbwsoft.com:4021/graphql',
  camUrl: 'https://data.campbowwow.com',

  // Search radius (in `mi`) when searching for nearest franchises.
  nearestFranchisesSearchRadius: 50,

  /*
    AWS Cognito
   */
  cognitoConfig: {
    UserPoolId: 'us-east-1_XhMg11zvx',
    ClientId: '6eit0okibc04cl7ga9vmvpnpd9',
  },

  /*
    Firebase
   */
  firebaseConfig: {
    apiKey: 'AIzaSyC1ctg83_ifFxcbxrVNlS5b5FRTlt7X-dc',
    authDomain: 'clientportaldev-224f2.firebaseapp.com',
    projectId: 'clientportaldev-224f2',
    storageBucket: 'clientportaldev-224f2.appspot.com',
    messagingSenderId: '729421717709',
    appId: '1:729421717709:web:09a0bbed69e7260d1c8984',
    measurementId: 'G-J3CNECGX4M',
  },

  /**
   * Possible values:
   *   dev - Edge
   *   testing - Test
   *   beta / pilot - Beta
   *   production - Prod
   */
  bucketVaccImages: 'Edge',

  /*
    TranSafe
   */
  tranSafe: {
    paymentFrameUrl: 'https://test.transafe.com:8665',
    iframeDomain: 'https://appstore.cbwsoft.com',
    iframeDomainPath: '/transafe',
  },

  /*
    HelloSign
   */
  helloSign: {
    config: {
      clientName: 'Client Portal',
      clientId: 'f0d374c0fe48a794390f74a8fc02e552',
      skipDomainVerification: false,
      testMode: true,
    },
  },

  /*
    Sentry
   */
  sentry: {
    dsn: 'https://6b491ba9e2644eb89ca50e8e78d13a51@o4504822055567360.ingest.sentry.io/4504822099279872',
    // Ref - https://docs.sentry.io/platforms/javascript/performance/instrumentation/automatic-instrumentation/#tracingorigins
    tracePropagationTargets: ['localhost', 'ccp-dev-gql.cbwsoft.com', /^\//],
    // Set tracesSampleRate to 1.0 to capture 100%
    // of transactions for performance monitoring.
    // We recommend adjusting this value in production
    tracesSampleRate: 1.0,
  },
};
